import { render, staticRenderFns } from "./ParamScaleList.vue?vue&type=template&id=9c46dd3a&scoped=true"
import script from "./ParamScaleList.vue?vue&type=script&lang=js"
export * from "./ParamScaleList.vue?vue&type=script&lang=js"
import style0 from "./ParamScaleList.vue?vue&type=style&index=0&id=9c46dd3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c46dd3a",
  null
  
)

export default component.exports